// Textes courts sur téléphone : on garde la première phrase complète (jamais de « … » au milieu d'une phrase).
const SEPS = [' · ', ' — ', ' ; ', ' (', ' : ', ', '];
export const premierePhrase = (t, max = 80) => {
  if (typeof t !== 'string' || t.length <= max) return t;
  const m = t.match(/^[^.!?…]*[.!?…](?=\s|$)/);
  if (m && m[0].trim().length >= 20 && m[0].length <= max + 15) return m[0].trim();
  const cut = t.slice(0, max);
  for (const sep of SEPS) { const i = cut.lastIndexOf(sep); if (i > 28) return cut.slice(0, i).trim(); }
  return t;
};
export const isMobileNow = () => typeof window !== 'undefined' && window.innerWidth <= 767;
export const courtMobile = (t, max = 80) => (isMobileNow() ? premierePhrase(t, max) : t);
